"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomService = void 0;
const core_1 = require("@angular/core");
let DomService = class DomService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.appendComponentToBody = (component) => {
            // Create a component reference from the component
            this.componentRef = this.componentFactoryResolver
                .resolveComponentFactory(component)
                .create(this.injector);
            // Attach component to the appRef so that it's inside the ng component tree
            this.appRef.attachView(this.componentRef.hostView);
            // Get DOM element from component
            const domElem = this.componentRef.hostView
                .rootNodes[0];
            // Append DOM element to the body
            document.body.appendChild(domElem);
            return this.componentRef.instance;
        };
        this.destroy = () => {
            this.appRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
        };
    }
};
DomService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof core_1.ComponentFactoryResolver !== "undefined" && core_1.ComponentFactoryResolver) === "function" ? _a : Object, typeof (_b = typeof core_1.ApplicationRef !== "undefined" && core_1.ApplicationRef) === "function" ? _b : Object, typeof (_c = typeof core_1.Injector !== "undefined" && core_1.Injector) === "function" ? _c : Object])
], DomService);
exports.DomService = DomService;
